"use client"
// Auto-generated by `npx boneyard-js build` — do not edit
import { registerBones } from 'boneyard-js'
import { configureBoneyard } from 'boneyard-js/react'

import _patient_card from './patient-card.bones.json'
import _patient_detail_info from './patient-detail-info.bones.json'
import _tpr from './tpr.bones.json'
import _dashboard_alert from './dashboard-alert.bones.json'
import _vaccination_records from './vaccination-records.bones.json'

configureBoneyard({"color":"oklch(0.922 0 0)"})

registerBones({
  "patient-card": _patient_card,
  "patient-detail-info": _patient_detail_info,
  "tpr": _tpr,
  "dashboard-alert": _dashboard_alert,
  "vaccination-records": _vaccination_records,
})
